import {API_DRIVER} from "../config/axios";

const getWinnersRequestUrl = (endpointUrl: string) => {
    return `/api/winners${endpointUrl}`
}


const WinnerService = {
    redeemWish: (codeHex: string) => {
        return API_DRIVER.put(getWinnersRequestUrl(''), undefined, {
            params: {
                code_hex: codeHex
            }
        })
    }
}

export default WinnerService
